package com.flowyride.core.map

import androidx.compose.ui.graphics.Color
import com.flowyride.core.designsystem.theme.FlowyColors
import com.flowyride.core.domain.analysis.SpeedBand

/** Color of the route line in [this] band: the map and its legend share it. */
val SpeedBand.routeColor: Color
    get() = when (this) {
        SpeedBand.TOWN -> FlowyColors.SpeedTown
        SpeedBand.SLOW -> FlowyColors.SpeedSlow
        SpeedBand.ROAD -> FlowyColors.SpeedRoad
        SpeedBand.FAST -> FlowyColors.SpeedFast
        SpeedBand.UNKNOWN -> FlowyColors.SpeedUnknown
    }
